<template>
  <v-menu offset-y allow-overflow>
    <template v-slot:activator="{ on }">
      <v-btn icon text x-small color="white" class="ma-0 pa-1" v-on="on">
        <v-icon size="15">more_vert</v-icon>
      </v-btn>
    </template>

    <v-list dense class="pa-0">
      <v-list-item
        v-for="(item, index) in menuItems"
        :key="index"
        v-if="item.visible"
        @click="item.action"
      >
        <v-list-item-avatar class="mb-0 mt-0">
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-avatar>

        <v-list-item-title>{{ item.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import MoreSVG from "@/assets/home/objectMenu/menu.svg";
import EditSVG from "@/assets/home/objectMenu/edit.svg";
import DetailSVG from "@/assets/home/objectMenu/detail.svg";
import ClearSVG from "@/assets/home/objectMenu/clear.svg";
import { mixin as clickaway } from "vue-clickaway";

export default {
  name: "FormOptionsMenu",

  components: { MoreSVG, EditSVG, DetailSVG, ClearSVG },

  mixins: [clickaway],

  props: {
    actionType: {
      type: String
    },

    objectPermission: {
      type: String
    },

    currentTab: {
      type: Object
    },
    workorderForm: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      menuOpened: false
    };
  },

  computed: {
    showMenuButton() {
      return (
        (this.actionType === "create" &&
          this.currentTab &&
          this.currentTab.type === "form" &&
          !this.currentTab.disable) ||
        (this.actionType === "view" && this.hasPermissionTo("update")) ||
        this.actionType === "edit"
      );
    },

    menuItems() {
      return [
        {
          label: this.$i18n.t("Edit"),
          icon: "edit",
          action: () => this.changeViewModeOfObject("edit"),
          visible:
            (this.isInMode("view") ||
              this.isInMode("splicing") ||
              this.isInMode("activities")) &&
            this.hasPermissionTo("update")
        },
        {
          label: this.$i18n.t("View"),
          icon: "visibility",
          action: () => this.changeViewModeOfObject("view"),
          visible: this.isInMode("edit")
        },
        {
          label: this.$i18n.t("Refresh"),
          icon: "refresh",
          action: () => this.$emit("refresh"),
          visible: this.isInMode("view") || this.isInMode("edit")
        },
        {
          label: this.$i18n.tc("Detail", 2),
          icon: "zoom_in",
          action: () => this.$emit("openDetails"),
          visible: this.workorderForm ? false : (this.isInMode("view") || this.isInMode("edit"))
        },
        {
          label: this.$i18n.t("ClearTabFields"),
          icon: "backspace",
          action: () => this.clearData(),
          visible: this.isInMode("create")
        }
      ];
    }
  },

  methods: {
    isInMode(mode) {
      return this.actionType === mode;
    },

    // TODO implement permission validation
    hasPermissionTo(permission) {
      let permissionsName = this.objectPermission + "_" + permission;
      return this.$store.getters.hasPermissionInRole(
        permissionsName,
        "fibercloud_web"
      );
    },

    changeViewModeOfObject(viewType) {
      this.$emit("changeViewModeOfObject", viewType);
    },

    clearData() {
      this.$emit("clearData");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/FormOptionsMenu.vue